import React from 'react'

import '../styles/Vision.css'

const Vision = () => {
  return (
      <div className='vision'>
          <h1 className='header'>Our Future Goal</h1>
          <section className='anime'>
              <div className="description">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et officia inventore, assumenda eum distinctio quidem eveniet ex, fugiat, esse possimus optio corporis rerum ab exercitationem. Totam esse voluptatibus aspernatur libero!</div>
              <ul className="container">
                <li className="points"></li>
                <li className="points"></li>
                <li className="points"></li>
                <li className="points"></li>
                <li className="points"></li>
              </ul>
          </section>
    </div>
  )
}

export default Vision